const BookCard = ({
    book,
    liked,
    onLikeClick,
    onActionClick,
    availabilityStyle,
    translations,
  }) => (
    <div className="w-full sm:w-1/2 lg:w-1/3 xl:w-1/4 p-2">
      <div className="bg-white shadow-lg rounded-lg p-3 flex-shrink-0 flex items-center text-right">
        <div className="w-1/3 p-2 mr-5">
          <img
            src={book.imageUrl}
            alt={book.title}
            className="object-cover rounded-lg ml-4"
          />
        </div>
        <div className="w-2/3 p-2 flex flex-col justify-between">
          <div>
            <h3 className="text-lg font-bold text-primary-blue" style={{ fontFamily: "Tajwal, sans-serif" }}>
              {book.title}
            </h3>
            <div className={`text-sm text-white px-2 py-1 rounded-lg inline-block ${availabilityStyle.bgColor}`} style={{ fontFamily: "Tajwal, sans-serif" }}>
              {availabilityStyle.text}
            </div>
            <div className="text-lg font-bold">
              {book.price} {translations.price}
            </div>
          </div>
          <div className="flex justify-between items-center mt-4">
            <button
              className={`bg-primary-blue text-white px-4 py-2 rounded-3xl ${
                availabilityStyle.btnDisabled ? "opacity-50 cursor-not-allowed" : ""
              }`}
              onClick={onActionClick}
              disabled={availabilityStyle.btnDisabled}
              style={{ fontFamily: "Tajwal, sans-serif" }}
            >
              {availabilityStyle.btnText}
            </button>
            <div className="text-gray-600">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill={liked ? "#ff3f52" : "none"}
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke={liked ? "#ff3f52" : "currentColor"}
                className="w-6 h-6 cursor-pointer"
                onClick={onLikeClick}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 
                  2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 
                  4.5 2.09C13.09 3.81 14.76 3 16.5 3 
                  19.58 3 22 5.42 22 8.5c0 3.78-3.4 
                  6.86-8.55 11.54L12 21.35z"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  
  export default BookCard;
  